// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_36QDA","content":"index_content_UjAKl","action":"index_action_2pcK7"};